import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X, ArrowRight } from "lucide-react";

const KEY = "harc-mockup-popup-dismissed";

export const Popup = () => {
  const [show, setShow] = useState(false);
  const closeRef = useRef(null);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setShow(true), 3500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (show) closeRef.current?.focus();
  }, [show]);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          role="dialog"
          aria-modal="true"
          aria-labelledby="popup-title"
          className="fixed bottom-6 right-6 z-50 w-[min(92vw,380px)]"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.35 }}
          data-testid="contact-popup"
          onKeyDown={(e) => e.key === "Escape" && dismiss()}
        >
          <div className="relative border border-[#004778]/30 bg-[#FFFFFF] p-7 shadow-xl">
            <button
              ref={closeRef}
              type="button"
              onClick={dismiss}
              aria-label="Dismiss"
              data-testid="popup-dismiss"
              className="absolute right-4 top-4 text-[#5C6B72] transition-colors hover:text-[#022A42]"
            >
              <X size={18} />
            </button>
            <p
              id="popup-title"
              className="harc-heading pr-6 text-2xl font-normal leading-snug text-[#004778]"
            >
              Have a complex challenge?
            </p>
            <p className="mt-3 text-sm leading-relaxed text-[#5C6B72]">
              HARC helps organizations turn insight into action. Tell us what you're trying to
              solve.
            </p>
            <Link
              to="/start-a-conversation"
              onClick={dismiss}
              data-testid="popup-cta"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#FFA100] px-6 py-3 text-xs font-bold uppercase tracking-[0.12em] text-[#022A42] transition-colors hover:bg-[#D98A00]"
            >
              Start a Conversation <ArrowRight size={13} aria-hidden="true" />
            </Link>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
